
function initContentBreadcrumb() {
  const breadcrumbContainer = document.querySelector('.breadcrumb-container');
  if (!breadcrumbContainer) {
    return;
  }

  const isEditing = document.body.classList.contains('editing');
  const firstComponentSelector = isEditing
    ? '.breadcrumb-container + .container-default .row > code:first-child + code + .component'
    : '.breadcrumb-container + .container-default .row > .component:first-child, .breadcrumb-container + .anchor-links + .container-default .row > .component:first-child';

  const firstComponent = document.querySelector(firstComponentSelector);

  if (firstComponent?.classList.contains('dark')) {
    breadcrumbContainer.classList.add('dark');
  } else {
    breadcrumbContainer.classList.remove('dark');
  }
}

export default initContentBreadcrumb;